import { useMemo } from "react";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useDebounce } from "use-debounce";
import { useAxiosProvider } from "../providers/axios-provider.js";
import "react/jsx-runtime";
import "axios";
const PAGE_SIZE = 10;
const getOpenAppointments = (axios) => async ({
  signal,
  queryKey,
  pageParam
}) => {
  var _a;
  const params = queryKey[1];
  const { data } = await axios.get("/api/v1/internal/open-appointments", {
    signal,
    params: {
      ...params,
      ...((_a = params.employeeReferenceIds) == null ? void 0 : _a.length) && {
        employeeReferenceIds: params.employeeReferenceIds.join(",")
      },
      size: PAGE_SIZE,
      page: pageParam ?? 0
    }
  });
  return data;
};
const useOpenAppointments = ({
  employeeReferenceIds,
  clinicReferenceId,
  auth,
  disabled
}) => {
  const { echoCore } = useAxiosProvider();
  const [debouncedEmployeeReferenceIds] = useDebounce(employeeReferenceIds, 500);
  const params = useMemo(
    () => ({
      clinicReferenceId: clinicReferenceId || "",
      employeeReferenceIds: debouncedEmployeeReferenceIds
    }),
    [clinicReferenceId, auth, debouncedEmployeeReferenceIds]
  );
  const queryKey = useMemo(() => ["open-appointments", params], [params]);
  const enabled = !disabled && !!clinicReferenceId && !!echoCore && !!auth;
  const { data, ...queryResult } = useInfiniteQuery({
    queryKey,
    queryFn: getOpenAppointments(echoCore),
    keepPreviousData: true,
    enabled,
    cacheTime: 0,
    staleTime: 0,
    getNextPageParam: (_, allPages) => {
      const lastPage = allPages[allPages.length - 1];
      return (lastPage == null ? void 0 : lastPage.last) ? void 0 : ((lastPage == null ? void 0 : lastPage.number) ?? 0) + 1;
    }
  });
  const flattenedData = useMemo(
    () => {
      var _a, _b;
      return ((_b = (_a = data == null ? void 0 : data.pages) == null ? void 0 : _a.flatMap(({ content }) => content)) == null ? void 0 : _b.reduce((accumulator, openAppointment) => {
        if (accumulator.some((prevOpenAppointment) => prevOpenAppointment.referenceId === openAppointment.referenceId)) {
          return accumulator;
        }
        return [...accumulator, openAppointment];
      }, [])) ?? [];
    },
    [data]
  );
  return {
    queryKey,
    queryResult,
    data: flattenedData
  };
};
export {
  useOpenAppointments
};
